"use strict";

exports.__esModule = true;

exports.default = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};


//////////////////
// WEBPACK FOOTER
// ./~/.6.26.0@babel-runtime/helpers/objectDestructuringEmpty.js
// module id = 50
// module chunks = 0